module.exports = __webpack_public_path__ + "img/34.1ecdb2a0.svg";